import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const createRequest = (flowType, data) =>
  axios.post(`${API}/requests`, { flowType, data }).then((r) => r.data);

export const getAvailability = (city) =>
  axios.get(`${API}/availability`, { params: city ? { city } : {} }).then((r) => r.data);

export const trackId = (id) =>
  axios.get(`${API}/track/${encodeURIComponent(id)}`).then((r) => r.data);

const admin = (token) => ({ headers: { "x-admin-token": token } });

export const authLogin = (email, password) =>
  axios.post(`${API}/auth/login`, { email, password }).then((r) => r.data);
export const authMe = (t) => axios.get(`${API}/auth/me`, admin(t)).then((r) => r.data);
export const authForgot = (email, origin) =>
  axios.post(`${API}/auth/forgot-password`, { email, origin }).then((r) => r.data);
export const authReset = (token, password) =>
  axios.post(`${API}/auth/reset-password`, { token, password }).then((r) => r.data);

const member = (t) => ({ headers: { "x-member-token": t } });
export const memberLogin = (email, password) =>
  axios.post(`${API}/member/login`, { email, password }).then((r) => r.data);
export const memberProfile = (t) => axios.get(`${API}/member/profile`, member(t)).then((r) => r.data);
export const memberEditAircraft = (t, id, body) =>
  axios.patch(`${API}/member/aircraft/${id}`, body, member(t)).then((r) => r.data);
export const memberEditProfile = (t, body) =>
  axios.patch(`${API}/member/me-profile`, body, member(t)).then((r) => r.data);
export const memberGenerateImage = (t, id) =>
  axios.post(`${API}/member/aircraft/${id}/generate-image`, {}, member(t)).then((r) => r.data);
export const memberAddAircraft = (t, body) =>
  axios.post(`${API}/member/aircraft`, body, member(t)).then((r) => r.data);
export const memberDeleteAircraft = (t, id) =>
  axios.delete(`${API}/member/aircraft/${id}`, member(t)).then((r) => r.data);
export const memberForgot = (email, origin) =>
  axios.post(`${API}/member/forgot-password`, { email, origin }).then((r) => r.data);
export const memberReset = (token, password) =>
  axios.post(`${API}/member/reset-password`, { token, password }).then((r) => r.data);
export const memberRegister = (name, email, password) =>
  axios.post(`${API}/member/register`, { name, email, password }).then((r) => r.data);
export const memberGoogleSession = (session_id) =>
  axios.post(`${API}/member/google-session`, { session_id }).then((r) => r.data);
export const memberGarage = (t) => axios.get(`${API}/member/garage`, member(t)).then((r) => r.data);
export const memberAddCar = (t, body) => axios.post(`${API}/member/cars`, body, member(t)).then((r) => r.data);
export const memberEditCar = (t, id, body) => axios.patch(`${API}/member/cars/${id}`, body, member(t)).then((r) => r.data);
export const memberDeleteCar = (t, id) => axios.delete(`${API}/member/cars/${id}`, member(t)).then((r) => r.data);
export const adminCreateMember = (t, body) =>
  axios.post(`${API}/admin/members`, body, admin(t)).then((r) => r.data);
export const adminGetMembers = (t) => axios.get(`${API}/admin/members`, admin(t)).then((r) => r.data);
export const adminGetAircraft = (t, memberId) =>
  axios.get(`${API}/admin/aircraft${memberId ? `?memberId=${memberId}` : ""}`, admin(t)).then((r) => r.data);
export const adminCreateService = (t, body) =>
  axios.post(`${API}/admin/services`, body, admin(t)).then((r) => r.data);
export const adminUploadMedia = (t, serviceId, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios.post(`${API}/admin/services/${serviceId}/media`, fd, { headers: { "x-admin-token": t } }).then((r) => r.data);
};
export const memberGetService = (t, id) =>
  axios.get(`${API}/member/service/${id}`, member(t)).then((r) => r.data);
export const mediaUrl = (path) => `${API}/media/${path}`;
export const adminEditMember = (t, id, body) =>
  axios.patch(`${API}/admin/members/${id}`, body, admin(t)).then((r) => r.data);
export const adminDeleteMember = (t, id) =>
  axios.delete(`${API}/admin/members/${id}`, admin(t)).then((r) => r.data);
export const adminCreateAircraft = (t, body) =>
  axios.post(`${API}/admin/aircraft`, body, admin(t)).then((r) => r.data);

export const adminGetRequests = (t) => axios.get(`${API}/admin/requests`, admin(t)).then((r) => r.data);
export const adminGetTickets = (t) => axios.get(`${API}/admin/tickets`, admin(t)).then((r) => r.data);
export const adminUpdateRequest = (t, id, body) =>
  axios.patch(`${API}/admin/requests/${id}`, body, admin(t)).then((r) => r.data);
export const adminCreateTicket = (t, id) =>
  axios.post(`${API}/admin/requests/${id}/ticket`, {}, admin(t)).then((r) => r.data);
export const adminUpdateTicket = (t, id, body) =>
  axios.patch(`${API}/admin/tickets/${id}`, body, admin(t)).then((r) => r.data);

export const adminGetAppointments = (t, city) =>
  axios.get(`${API}/admin/appointments`, { ...admin(t), params: city ? { city } : {} }).then((r) => r.data);
export const adminCreateAppointment = (t, body) =>
  axios.post(`${API}/admin/appointments`, body, admin(t)).then((r) => r.data);
export const adminUpdateAppointment = (t, id, body) =>
  axios.patch(`${API}/admin/appointments/${id}`, body, admin(t)).then((r) => r.data);
export const adminDeleteAppointment = (t, id) =>
  axios.delete(`${API}/admin/appointments/${id}`, admin(t)).then((r) => r.data);

// ---- Service Tracker (autos) ----
export const publicService = (token) =>
  axios.get(`${API}/servicio/${token}`).then((r) => r.data);
export const serviceMarketing = (token, optIn) =>
  axios.patch(`${API}/servicio/${token}/marketing`, { optIn }).then((r) => r.data);
export const serviceReview = (token, rating, comment) =>
  axios.patch(`${API}/servicio/${token}/review`, { rating, comment }).then((r) => r.data);

// tech endpoints accept either member (technician) or admin token
const techHeaders = (mtoken, atoken) => {
  const h = {};
  if (mtoken) h["x-member-token"] = mtoken;
  if (atoken) h["x-admin-token"] = atoken;
  return { headers: h };
};
export const techServices = (mtoken, atoken) =>
  axios.get(`${API}/tech/services`, techHeaders(mtoken, atoken)).then((r) => r.data);
export const techAssign = (mtoken, atoken, sid, body) =>
  axios.patch(`${API}/tech/autos-service/${sid}/assign`, body || {}, techHeaders(mtoken, atoken)).then((r) => r.data);
export const techSetState = (mtoken, atoken, sid, state) =>
  axios.patch(`${API}/tech/autos-service/${sid}/state`, { state }, techHeaders(mtoken, atoken)).then((r) => r.data);
export const techNotes = (mtoken, atoken, sid, body) =>
  axios.patch(`${API}/tech/autos-service/${sid}/notes`, body, techHeaders(mtoken, atoken)).then((r) => r.data);
export const techUploadPhoto = (mtoken, atoken, sid, kind, pair, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios.post(`${API}/tech/autos-service/${sid}/photo?kind=${kind}&pair=${pair}`, fd, techHeaders(mtoken, atoken)).then((r) => r.data);
};
